import React, { useContext } from 'react';
import { ReactComponent as RadialImage } from '@/assets/img/emily-radial.svg';
import Lottie from 'lottie-react';
import animationData from '@/assets/animation/emily-rotating-animation.json'; // Adjust the path to your JSON file
import animationDataBg from '@/assets/animation/emily-bg.json'; // Adjust the path to your JSON file
import './WelcomeBanner.scss';
import { UserContext } from '@/routes';
type WelcomeBannerProps = {
  chatModeStarted: boolean;
  hideText?: boolean;
};

export const WelcomeBanner = ({ chatModeStarted, hideText }: WelcomeBannerProps) => {
  const userContext = useContext(UserContext);
  return (
    <div
      className={`welcome-banner ${chatModeStarted ? 'chat' : 'landing'} w-full flex  ${
        userContext?.isLandscape ? 'landscape' : 'portrait'
      } `}
    >
      {chatModeStarted ? (
        <div>
          <div>
            <Lottie
              animationData={animationDataBg}
              loop={true}
              autoplay={true}
              className="logo-bg-animation"
            />
          </div>
          <div className="landing-text relative z-10 ">
            <h3 className="m-0">Its Emily here to help!</h3>
            <p>
              I&apos;m your virtual assistant for business insights, grooming tips, and service
              control.
            </p>
          </div>
        </div>
      ) : (
        <div className="inner-section flex justify-center items-center">
          <div className="content">
            <div className="relative lottie-container">
              <span className="circle-container">
                <span className="gradient">
                  <RadialImage />
                </span>
                <Lottie
                  animationData={animationData}
                  loop={true}
                  autoplay={true}
                  className="spinning-animation"
                />
              </span>
              <Lottie
                animationData={animationDataBg}
                loop={true}
                autoplay={true}
                className="logo-bg-animation"
              />
              <div className="fading-gradient"></div>

              {!hideText && (
                <div className="landing-text relative z-10 ">
                  <h3 className="m-0">Its Emily here to help!</h3>
                  <p>
                    I&apos;m your virtual assistant for business insights, grooming tips, and
                    service control.
                  </p>
                </div>
              )}
              <div className="top-fade"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
